module.exports = __webpack_public_path__ + "img/gcloud.fe8c52d5.png";